// extracted by mini-css-extract-plugin
module.exports = {"shimmerInnerWrap":"ArticleLoader_shimmerInnerWrap__1_PJd","shimmerRight":"ArticleLoader_shimmerRight__2szJC"};